import { UseQueryResult, useQuery } from 'react-query';
import { getAllActiveOrgs } from 'src/api/organization';
import { UserStoreObject } from 'src/stores/UserStore';
import { Organization } from 'src/stores/OrgStore';

export const allActiveOrgsKey = 'allActiveOrgs';

export const useAllActiveOrgs = (): UseQueryResult<Organization[]> => {
    return useQuery({
        queryKey: [allActiveOrgsKey],
        queryFn: async () => {
            return await getAllActiveOrgs();
        },
        enabled: UserStoreObject.isGraphiumAdmin(),
        initialData: [],
    });
};
